import { z } from 'zod';
import { IsoDateTime, PageMeta, PageRequest, MutationReason } from './_common.js';
export const CosmeticType = z.enum(['avatar_frame', 'badge', 'particle_effect', 'room_decor']);
export const CosmeticUnlockMethod = z.enum(['iap', 'leaderboard', 'event', 'admin_grant', 'tier_milestone']);
export const Cosmetic = z.object({
    cosmetic_id: z.string(),
    type: CosmeticType,
    name: z.string(),
    asset_url: z.string(),
    thumbnail_url: z.string().nullable(),
    unlock_method: CosmeticUnlockMethod,
    rarity: z.enum(['common', 'rare', 'epic', 'legendary']).default('common'),
    active: z.boolean(),
    created_at: IsoDateTime,
});
export const CosmeticListRequest = PageRequest.extend({
    type: CosmeticType.optional(),
    unlock_method: CosmeticUnlockMethod.optional(),
    active: z.boolean().optional(),
    q: z.string().optional(),
});
export const CosmeticListResponse = z.object({
    items: z.array(Cosmetic),
    page: PageMeta,
});
export const CosmeticCreateRequest = z.object({
    cosmetic_id: z.string().min(3).max(80).regex(/^[a-z0-9_]+$/),
    type: CosmeticType,
    name: z.string().min(2).max(80),
    asset_url: z.string().url(),
    thumbnail_url: z.string().url().nullable().default(null),
    unlock_method: CosmeticUnlockMethod,
    rarity: z.enum(['common', 'rare', 'epic', 'legendary']).default('common'),
    reason: MutationReason,
});
export const CosmeticCreateResponse = Cosmetic;
export const CosmeticGrantRequest = z.object({
    user_id: z.string(),
    cosmetic_id: z.string(),
    source_note: z.string().max(120).default('admin_grant'),
    reason: MutationReason,
});
export const CosmeticGrantResponse = z.object({
    user_id: z.string(),
    cosmetic_id: z.string(),
    unlocked_at: IsoDateTime,
});
export const CosmeticBulkGrantRequest = z.object({
    cohort_id: z.string().nullable(),
    user_ids: z.array(z.string()).max(10000).default([]),
    cosmetic_id: z.string(),
    source_note: z.string().max(120).default('admin_bulk_grant'),
    reason: MutationReason,
});
export const CosmeticBulkGrantResponse = z.object({
    job_id: z.string(),
    estimated_users: z.number().int(),
    status: z.enum(['queued', 'running', 'completed', 'failed']),
});
export const CosmeticRevokeRequest = z.object({
    user_id: z.string(),
    cosmetic_id: z.string(),
    reason: MutationReason,
});
export const CosmeticRevokeResponse = z.object({
    ok: z.literal(true),
});
//# sourceMappingURL=cosmetics.js.map